/** Well status → i18n key map, shared by the explorer and the record hub. */
import type { WellStatus } from "@api/types";
import type { MessageKey } from "@i18n/messages";

export const STATUS_KEY: Record<WellStatus, MessageKey> = {
  drilling: "status.drilling",
  completion: "status.completion",
  producing: "status.producing",
  suspended: "status.suspended",
};

/**
 * Coarse `event_type` → i18n key map. The four known job families (as emitted
 * by Oxbo-P) localize to EN/ES/PT; an unknown type falls back to its raw
 * lowercase string via `eventTypeLabel`.
 */
export const EVENT_TYPE_KEY: Record<string, MessageKey> = {
  drilling: "eventType.drilling",
  completion: "eventType.completion",
  workover: "eventType.workover",
  intervention: "eventType.intervention",
};

/** Localized display label for an event_type; falls back to the raw value. */
export function eventTypeLabel(
  eventType: string,
  t: (key: MessageKey) => string,
): string {
  const key = EVENT_TYPE_KEY[eventType.toLowerCase()];
  return key ? t(key) : eventType;
}
